import { render, staticRenderFns } from "./ChangeLabel.vue?vue&type=template&id=2a0195ba&scoped=true&"
import script from "./ChangeLabel.vue?vue&type=script&lang=js&"
export * from "./ChangeLabel.vue?vue&type=script&lang=js&"
import style0 from "./ChangeLabel.vue?vue&type=style&index=0&id=2a0195ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0195ba",
  null
  
)

export default component.exports